import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

// The single, shared axios instance used across the app (auth header + global
// 401 handling in one place).
const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  timeout: 30000,
});

api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      if (window.location.pathname !== '/login') {
        // ProtectedRoute will redirect to the login page.
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

/** Extract a human-readable message from an axios error. */
export function apiErrorMessage(error: unknown, fallback = 'Request failed'): string {
  const err = error as AxiosError<any>;
  const detail = err?.response?.data?.detail ?? err?.response?.data?.message;
  if (Array.isArray(detail)) {
    return detail
      .map((d: any) => (d?.loc ? `${d.loc[d.loc.length - 1]}: ${d.msg}` : d?.msg || String(d)))
      .join('\n');
  }
  if (typeof detail === 'string') return detail;
  if (err?.message) return err.message;
  return fallback;
}

export default api;
